import { render, staticRenderFns } from "./EditCategoryModal.vue?vue&type=template&id=620b8a58&scoped=true"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./EditCategoryModal.vue?vue&type=style&index=0&id=620b8a58&prod&lang=scss"
import style1 from "./EditCategoryModal.vue?vue&type=style&index=1&id=620b8a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b8a58",
  null
  
)

export default component.exports